import { IWikiModel } from '@app/core/interfaces/wiki-model-interface';

export const aptitudes_model: Array<IWikiModel> = [
    {
        imageUrl: 'assets/images/press/aptitudes/simplicidad',
        title: 'symplicity_title',
        content: 'symplicity_info',

        imageSettings: {
            width: 300,
            height: 300
        }
    },
    {
        imageUrl: 'assets/images/press/aptitudes/transparencia',
        title: 'transparency_title',
        content: 'transparency_info',

        imageSettings: {
            width: 300,
            height: 300
        }
    },
    {
        imageUrl: 'assets/images/press/aptitudes/calidez-humana',
        title: 'customer_s_title',
        content: 'customer_s_info',

        imageSettings: {
            width: 300,
            height: 300
        }
    },
    {
        imageUrl: 'assets/images/press/aptitudes/innovacion',
        title: 'innovation_title',
        content: 'innovation_info',

        imageSettings: {
            width: 300,
            height: 300
        }
    }
];
